<template>

    <div class="infoframe">
        <div class="infohead">
            <div style="margin-left:32px">
               出签
            </div>
        </div>
        
        <el-form ref="form"  label-width="80px" class="infoform">
             <el-form-item label="客户类型">
            <el-radio-group v-model="radio1" @change="typeChange">
      <el-radio-button label="团单出签"></el-radio-button>
      <el-radio-button label="个检出签"></el-radio-button>
    </el-radio-group>
     </el-form-item>
             <el-form-item label="合同号" >
                <el-input v-model="ContractID" maxlength="6" :disabled="IsContractID" ></el-input>
            </el-form-item>
            <el-form-item label="证件类型">
              <el-select v-model="PaperType" placeholder="请选择" @change="IDChange">
    <el-option
      v-for="item in IDOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                
            </el-form-item>
            <el-form-item label="身份证号">
                <el-input v-model="PaperValue" maxlength="18" ></el-input>
            </el-form-item>
            <el-form-item label="客户姓名">
                <el-input  v-model="Name"></el-input>
            </el-form-item>
             
             <el-form-item label="客户性别">
              <el-select v-model="Sex" placeholder="请选择" :disabled="isSex" @change="SexChange">
    <el-option
      v-for="item in SexOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                
            </el-form-item>
            <el-form-item label="手机号码">
                <el-input  v-model="Mobile" maxlength="11" ></el-input>
            </el-form-item>
            <el-form-item label="出生日期">
                <el-date-picker
      v-model="BirthDay"
      type="date" value-format="yyyy-MM-dd"
      placeholder="选择出生日期" :disabled="isBirthDay">
    </el-date-picker>
            </el-form-item>
            <el-form-item label="产品编号">
              <el-select v-model="product" placeholder="请选择">
    <el-option
      v-for="item in ddlproduct"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                
            </el-form-item>
             <el-form-item label="单位名称">
              <el-select v-model="company" placeholder="请选择">
    <el-option
      v-for="item in companyList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                
            </el-form-item>
            <el-form-item label="付款方式">
              <el-select v-model="m_WKJsfs" placeholder="请选择">
    <el-option
      v-for="item in ddlWKJsfs"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
              </el-select>
                
            </el-form-item>

            <el-form-item label="备注">
                <el-input  v-model="Remarks"></el-input>
            </el-form-item>
              <el-form-item label="服务人"  >
              <el-select v-model="Manager" placeholder="请选择">
    <el-option
      v-for="item in ddlManagerList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                
            </el-form-item>
            
        </el-form>
       
        <div style="text-align:center">
         <el-button type="primary" :disabled="isOk" @click="cost">确定</el-button> 
        </div>
       

    </div>
    
</template>
<script>
import {restbase} from '../rest'
import {foowwLocalStorage} from '../rest'
    export default {
        name: 'info',
        data() {
            return {
                 radio1: '团单出签',
                 radio2: '个检出签',
                 TianType:'团单出签',
                 IsContractID:false,
                 admin:[],
              ContractID:'',
              PaperValue:'',
              Name:'',
              Mobile:'',
              VipLevel:'',
              isOk:false,
              Remarks:'',
                SexOptions: [{value: '男',
                label: '男'},{value: '女',
                label: '女'}],
                JianKangguWen:'',
                ddlJianKangguWen:[],
                product:'',
                productList:[],
                ddlproduct:[],
                Sex:'',
                isCard:false,
                isPaper:false,
                fullscreenLoading: false,
                IsVipLevel:true,
                UserType:'团单',
                ddlWKJsfs:[{value: '统一付款',
                label: '统一付款'},{value: '检前交费',
                label: '检前交费'}],
                m_WKJsfs:'统一付款',
                PaperType:'身份证',
                IDOptions: [{value: '身份证',
                label: '身份证'},{value: '护照',
                label: '护照'}],
                BirthDay:'',
                isSex:true,
                isBirthDay:true,
                company:'',
                companyList:[],
                Gender:'',
                Manager:'',
                ddlManagerList:[],

            }
  
   
        },
           created(){
           
               if (this.admin.length == 0) {
                 this.admin=JSON.parse(foowwLocalStorage.get('admin'));
                 if(this.admin==null){
                this.$alert('登录失效，请重新登录！', '错误', {
                         confirmButtonText: '确定',
                         callback: action => {
                         this.$router.push('/YBLogin');
                          }
                         });
                        
                }
               }
               this.fetchManager();

            　
           
        },
		methods: {
             IDChange(){
                if(this.PaperType=='护照'){
                    this.isSex=false;
                    this.isBirthDay=false;
                    this.isPaper=true;
                }else{
                    this.isSex=true;
                    this.isBirthDay=true;
                    this.isPaper=false;
                }
             },
            typeChange(value){
                if(value=="个检出签"){
                    this.IsContractID=true;
                    this.ContractID='';
                    console.log(1);
                    this.productList=[];
                    this.ddlproduct=[];
                    this.companyList=[];
                    this.company='个人';
                    this.product='';
                    this.UserType='个检';
                    this.m_WKJsfs='检前交费';
                    this.fetchPrivateProduct();
                }else{
                    this.IsContractID=false;
                    this.productList=[];
                    this.ddlproduct=[];
                     this.companyList=[];
                    this.company='';
                    this.product='';
                    this.UserType='团单';
                    this.m_WKJsfs='统一付款';
                }
            },
             //身份证识别性别出生日期
             inputChange() {
      const reg =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (reg.test(this.PaperValue)&&this.PaperValueValit(this.PaperValue)) {
       
        var org_gender = this.PaperValue.substring(16, 17);
        var sex = org_gender % 2 == 1 ? "男" : "女";
        var Gender = org_gender % 2 == 1 ? "10" : "01";
        this.Sex = sex;
         this.Gender = Gender;
         let birth =
          this.PaperValue.substring(6, 10) +
          "-" +
          this.PaperValue.substring(10, 12) +
          "-" +
          this.PaperValue.substring(12, 14);
        this.BirthDay = birth;
        console.log(this.BirthDay);
        
        this.PaperValueChange();
        
      } else {
        this.$notify.error({
          title: '错误',
          message:'身份证号码不合法'
         });
          
      }
             },
             PaperValueValit(value){
                 var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];//加权因子
      var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];//校验码
      if (/^\d{17}\d|x$/i.test(value)) {
        var sum = 0, idx;
        for (var i = 0; i < value.length - 1; i++) {
          // 对前17位数字与权值乘积求和
          sum += parseInt(value.substr(i, 1), 10) * arrExp[i];
        }
        // 计算模（固定算法）
        idx = sum % 11;
        // 检验第18为是否与校验码相等
        if (arrValid[idx] == value.substr(17, 1).toUpperCase()) {
          return true;
        } else {
          return false;
        }
      } else {
       return false;
      }
             },
             ContractChange(){
             
                this.$http.post(restbase() + "asp/IsValidateContractID", {
                    ContractID: this.ContractID,
                    Name:this.admin.CnName
                }).then(response=>{
                  
                    
                    const d = JSON.parse('['+response.data.d+']');
                      console.log(d);
                    if (d[0].code !== '0') {
                        this.$notify.error({
                            title: '错误',  
                            message: d[0].description
                        });
                    } 
                    else {
                        this.isCard=true;
                        this.productList = [];
                        d.forEach(e => {
                        this.productList.push({label:e.value, value:e.value, genner:e.genner});
                        
                        });
                    this.ddlproduct=this.productList;
                        }
                }, response=>{
                    // eslint-disable-next-line  this.$root.admin.UserName
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
                  this.$http.post(restbase() + "asp/GetCompany", {
                    ContractID: this.ContractID
                }).then(response=>{
                  
                    
                    const d = JSON.parse('['+response.data.d+']');
                      console.log(d);
                    if (d[0].code !== '0') {
                        this.$notify.error({
                            title: '错误',  
                            message: d[0].description
                        });
                    } 
                    else {
                        this.companyList = [];
                        d.forEach(e => {
                        this.companyList.push({label:e.label, value:e.label});
                        
                        });
                        }
                }, response=>{
                    // eslint-disable-next-line  this.$root.admin.UserName
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
             },
              PaperValueChange(){
             
                this.$http.post(restbase() + "asp/PaperChange", {
                    PaperValue: this.PaperValue
                }).then(response=>{
                    console.log(response.data.d);
                    const r = JSON.parse(response.data.d);
                    this.isPaper=true;
                    if (r.code == '0') {
                       if(r.Name!='')
                       {
                        this.Name=r.Name;
                       this.Mobile=r.Mobile;
                       this.Sex=r.Gender;
                       this.Gender=r.Gender == "男" ?'10'  : "01";
                       this.PaperType=r.PaperType;
                       }
                       this.ProductChange();
                    } 
                }, response=>{
                    // eslint-disable-next-line  this.$root.admin.UserName
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
             },
             ProductChange(){
                this.product="请选择";
                this.ddlproduct=this.productList.filter(data =>data.genner==this.Gender || data.genner=='11');
               console.log(this.Gender);
             },
              SexChange(){
                console.log(1);
                this.Gender=this.Sex == '男' ?'10':'01';
                this.ProductChange();
             }
             ,
             cost(){
                console.log(this.m_WKJsfs);
                 if(this.admin.CnName==''){
                    this.$notify.error({
                            title: '错误',
                            message: '登录失效，请重新登录！'
                            ,callback: action => {
                              this.$router.push('/YBLogin');
                             }
                        });
                    return;
                }
                if((this.ContractID==''||this.ContractID.length!=6) && this.UserType=='团单'){
                    this.$notify.error({
                            title: '错误',
                            message: '请正确填写6位合同号'
                        });
                    return;
                }
                if((this.PaperValue==''||this.PaperValue.length!=18)&&this.PaperType=='身份证'){
                    this.$notify.error({
                            title: '错误',
                            message: '请正确填写18位身份证号码'
                        });
                    return;
                }
                 if(this.PaperType=='' || this.PaperType=='请选择'){
                    this.$notify.error({
                            title: '错误',
                            message: '请选择证件号类型'
                        });
                    return;
                }
                if((!this.isCard && this.UserType=='团单')|| !this.isPaper){
                    this.$notify.error({
                            title: '错误',
                            message: '卡号或身份证号未通过验证！'
                        });
                    return;
                }
                if(this.Name==''){
                    this.$alert('请正确填写客户姓名');return;
                    
                }
                if(this.Sex=='' ||this.Sex=='请选择'){
                    this.$notify.error({
                            title: '错误',
                            message: '请选择客户性别'
                        });
                    return;
                }
                if(this.Mobile==''){
                    this.$notify.error({
                            title: '错误',
                            message: '请填写手机号码'
                        });
                    return;
                }
                
                 if(this.product=='' ||this.product=='请选择'){
                    this.$notify.error({
                            title: '错误',
                            message: '请选择产品'
                        });
                    return;
                }
                 if(this.company=='' ||this.company=='请选择'){
                    this.$notify.error({
                            title: '错误',
                            message: '请选择一个单位'
                        });
                    return;
                }
                 if(this.Manager=='' ||this.Manager=='请选择'){
                    this.$notify.error({
                            title: '错误',
                            message: '请选择一个客户服务人'
                        });
                    return;
                }
               if( this.BirthDay==''){
                     this.$notify.error({
                            title: '错误',
                            message: '请选择生日'
                        });
                    return; 
                }
                
                  const loading = this.$loading({
          lock: true,
          text: '操作中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
                this.$http.post(restbase() + "asp/Order_TD", {
                    ContractNum: this.ContractID,PaperValue:this.PaperValue.toUpperCase(),Name:this.Name.trim(),Product:this.product, Mobile:this.Mobile,
                     Remark: this.Remarks, Operater: this.admin.CnName,UserType:this.UserType,m_WKJsfs:this.m_WKJsfs
                    ,PaperType:this.PaperType,BirthDay:this.BirthDay,Gender:this.Sex,Company:this.company,Manager:this.Manager
                }).then(response=>{
                    loading.close();
                    const r = JSON.parse(response.data.d);
                    console.log(r);
                    if (r.code !== '0') {
                        this.$notify.error({
                            title: '错误',
                            message: r.description
                        });
                    } 
                    else {
                     
                     this.$alert('出签已成功', '出签', {
                        confirmButtonText: '确定',
                        callback: action => {
                        this.isOk=false;
                        this.$router.push('TDMember');
                        }
                        });
                      
                        }
                }, response=>{
                    // eslint-disable-next-line  this.$root.admin.UserName
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
                
                
             } ,
             //查找所有友邦产品
              fetchPrivateProduct() {
        
                 this.$http.post(restbase() + "asp/GetPrivateProduct").then(response=>{
                   this.loading=false;
                   
                    const d = JSON.parse('['+response.data.d+']');
                    this.productList = [];
                    d.forEach(e => {
                      this.productList.push({label:e.value, value:e.value, genner:e.genner});
                        
                    });
                   this.ddlproduct=this.productList;
                }, response=>{
                    // eslint-disable-next-line  this.$root.admin.UserName
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
             }, 
              fetchManager() {
        
                 this.$http.post(restbase() + "asp/GetManager").then(response=>{
                   this.loading=false;
                   
                    const d = JSON.parse('['+response.data.d+']');
                    this.ManagerList = [];
                    d.forEach(e => {
                      this.ManagerList.push({label:e.value, value:e.value});
                        
                    });
                   this.ddlManagerList=this.ManagerList;
                }, response=>{
                    // eslint-disable-next-line  this.$root.admin.UserName
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
             }, 
        },
		 watch: {
		     ContractID: function () {
             if(this.ContractID.length==6)
		     { 
                console.log(2);
                this.ContractChange();
             }
		    },
            PaperValue: function () {
             if(this.PaperValue.length==18)
		     { 
                this.inputChange();
                this.ProductChange();
             }
		    }
            
         }
         
    }
</script>

<style> 
.infoframe {
        position: relative;
        height: 970px;
         width:100%;
        margin:0 auto;
        border-radius: 4px;
        border-left: 1px solid #ddd;
        box-shadow: 3px 3px 3px #aaa;
        background-color: white;
    }
    .infohead {
        width:100%;
        height:48px;
        line-height:48px;
        padding:0;
        color:white;
        background-color:#80A0D0;
        border-radius:4px 4px 0 0;
    }
    .infoform {
        padding: 10px 10px 10px 10px;
    }
  
   
</style>